import type { FC } from 'react';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { style } from 'typestyle';

export type AvatarProps = {
  username: string;
  styleProps?: {
    width: string;
    height: string;
  };
};

const menuBubbleDims = 32;
const className = style({
  backgroundPosition: '50%',
  backgroundSize: 'cover',
  borderRadius: '50%',
  height: menuBubbleDims,
  minHeight: menuBubbleDims,
  minWidth: menuBubbleDims,
  overflow: 'hidden',
  width: menuBubbleDims,
});

export const Avatar: FC<AvatarProps> = ({ username, styleProps }) => {
  const style = {
    backgroundImage: `url('https://internal-cdn.amazon.com/badgephotos.amazon.com/?uid=${username || 'empty'}`,
    height: styleProps !== undefined ? (styleProps.height ?? menuBubbleDims) : menuBubbleDims,
    width: styleProps !== undefined ? (styleProps.width ?? menuBubbleDims) : menuBubbleDims,
  };

  return (
    <OverlayTrigger key="avatar" overlay={<Tooltip id="username-tooltip">{username}</Tooltip>} placement="bottom">
      <div className={className} id={`${username}-avatar`} style={style} title={username}></div>
    </OverlayTrigger>
  );
};
